import { ColumnDescription } from "react-bootstrap-table-next";
import Table from "../../../../../Components/Table";
import { IClienteDadosUau } from "../../../../../Interfaces/Geral/InformacoesVenda/InformacoesVendaInterfaces";
import { formatMoneyReais } from "../../../../../Tools/FormatTools";
import moment from "moment";

interface InfoBoletoProps {
    clienteDados: IClienteDadosUau | undefined;
}

export default function InfoBoleto(props: InfoBoletoProps) {
    const tableviewColumns: Array<ColumnDescription> = [
        {
            dataField: "NumArq_Bol",
            text: "Nº Remessa",
        },
        {
            dataField: "NumDoc_Bol",
            text: "Nossa Nº",
        },

        {
            dataField: "Banco_Bol",
            text: "Boleto",
        },
        {
            dataField: "Empresa_bol",
            text: "Empresa",
        },
        {
            dataField: "DESC_EMP",
            text: "Desc. Empresa",
        },
        {
            dataField: "ObraPrc_Rea",
            text: "Obra",
        },
        {
            dataField: "NumVendPrc_Rea",
            text: "Nº Venda",
        },
        {
            dataField: "TipoPrc_Rea",
            text: "Tipo Parcela",
        },
        {
            dataField: "NumParcPrc_Rea",
            text: "Nº Parcela",
        },
        {
            dataField: "ValorPar_Rea",
            text: "Valor Parcela",
            formatter: (_, row) => <>{formatMoneyReais(row.ValorPar_Rea)}</>,
        },
        {
            dataField: "Agrupado_Rea",
            text: "Agrupado",
        },
        {
            dataField: "DataGera_Bol",
            text: "Data Geração",
            formatter: (_, row) => {
                return <>{moment(row.DataGera_Bol).format("LL")}</>;
            },
        },
        {
            dataField: "DATAPROR_PRC",
            text: "Data Prorrogação",
            formatter: (_, row) => {
                return <>{moment(row.DATAPROR_PRC).format("LL")}</>;
            },
        },
        {
            dataField: "DataVenc_bol",
            text: "Data Vencimento",
            formatter: (_, row) => {
                return <>{moment(row.DataVenc_bol).format("LL")}</>;
            },
        },
        {
            dataField: "Status_Rea",
            text: "Status",
        },
        {
            dataField: "ClienteVen_Bol",
            text: "Cód. Cliente",
        },
        {
            dataField: "NOME_PES",
            text: "Nome Cliente",
        },
        {
            dataField: "CPF_PES",
            text: "CPF/CNPJ",
        },
        {
            dataField: "TIPO_PES",
            text: "Fis. / Jur.",
        },
        {
            dataField: "ComRes_Rea",
            text: "Com Resíduo",
        },
        {
            dataField: "ValRes_Rea",
            text: "Vlr. Resíduo",
            formatter: (_, row) => <>{formatMoneyReais(row.ValRes_Rea)}</>,
        },
        {
            dataField: "Antecipado_Rea",
            text: "Antecipado",
        },
        {
            dataField: "ValDoc_Bol",
            text: "Vlr. Boleto",
            formatter: (_, row) => <>{formatMoneyReais(row.ValDoc_Bol)}</>,
        },
        {
            dataField: "ValDesconto_Bol",
            text: "Desconto",
            formatter: (_, row) => <>{formatMoneyReais(row.ValDesconto_Bol)}</>,
        },
        {
            dataField: "StatusCarteira_Rea",
            text: "Status Carteira",
        },
        {
            dataField: "LocalPgto_Bol",
            text: "Local Pagamento",
        },
        {
            dataField: "NumDoc_Bol",
            text: "Documento",
        },
        {
            dataField: "Aceite_Bol",
            text: "Aceite",
        },
        {
            dataField: "Especie_Bol",
            text: "Moeda",
        },
        {
            dataField: "Carteira_Bol",
            text: "Carteira",
        },
        {
            dataField: "EspecieDoc_Bol",
            text: "Espécie",
        },
        {
            dataField: "AgCodCed_Bol",
            text: "Agência Cedente",
        },
        {
            dataField: "NossoNum_Bol",
            text: "Nosso Nº Banco",
        },
        {
            dataField: "ValDeducao_Bol",
            text: "Dedução",
            formatter: (_, row) => <>{formatMoneyReais(row.ValDeducao_Bol)}</>,
        },
        {
            dataField: "ValMoraMulta_Bol",
            text: "Mora/Multa",
            formatter: (_, row) => (
                <>{formatMoneyReais(row.ValMoraMulta_Bol)}</>
            ),
        },
        {
            dataField: "ValAcrescimo_Bol",
            text: "Acréscimo",
            formatter: (_, row) => (
                <>{formatMoneyReais(row.ValAcrescimo_Bol)}</>
            ),
        },
        {
            dataField: "ValCobrado_Bol",
            text: "Valor Cobrado",
            formatter: (_, row) => <>{formatMoneyReais(row.ValCobrado_Bol)}</>,
        },
        {
            dataField: "InstrucaoImp_bol",
            text: "Mensagem Impressa pelo banco",
            classes: "p-2 ws-nowrap",
        },
        {
            dataField: "Instrucao_Bol",
            text: "Mensagem Impressa pelo UAU",
            classes: "p-2 ws-nowrap",
        },
        {
            dataField: "CampoLivre_Bol",
            text: "Campo Livre",
        },
        {
            dataField: "ENDERECO_PEND",
            text: "Endereço",
        },
        {
            dataField: "NUMEND_PEND",
            text: "Número",
        },
        {
            dataField: "BAIRRO_PEND",
            text: "Bairro",
        },
        {
            dataField: "CIDADE_PEND",
            text: "Cidade",
        },
        {
            dataField: "CEP_PEND",
            text: "CEP",
        },
        {
            dataField: "CEP_PEND",
            text: "Conta Corrente",
        },
        {
            dataField: "BoletoParcial_bol",
            text: "Boleto Parcial",
            formatter: (_, row) => <>{row.BoletoParcial_bol ? "Sim" : "Não"}</>,
        },
    ];

    return (
        <div
            className="card-body mt-n2 table-responsive"
            style={{ overflowX: "scroll" }}
        >
            <Table
                columns={tableviewColumns}
                data={props?.clienteDados?.BOLETOS ?? []}
                keyField="ID_CLIENTE"
                noDataIndication={() => (
                    <div className="text-black-50 text-center">
                        Nenhum Boleto encontrado
                    </div>
                )}
                defaultStyle={{
                    align: "center",
                    classes: "p-4",
                }}
                noHover
                bordered={false}
                loading={false}
                noSearch
                totalPages={Math.ceil(
                    props?.clienteDados?.BOLETOS?.length ?? 0 / 10
                )}
                striped={true}
            />
        </div>
    );
}
